import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders children into the sidebar's mount point in Shell.
 *
 * The dashboard owns the tool state but the panels belong in the nav column, where
 * they cannot cover the map legend or the radar scrubber. A portal keeps the state
 * where it is instead of lifting it into the shell for two pages that use it.
 *
 * The mount point only exists once Shell has rendered, so resolve it in an effect
 * rather than at module scope — on the first paint it is legitimately absent.
 */
export default function SidebarPanel({ children }: { children: React.ReactNode }) {
  const [host, setHost] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setHost(document.getElementById('ww-sidebar-panels'));
  }, []);

  if (!host) return null;
  return createPortal(children, host);
}
